import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import Backend from "i18next-http-backend";
import { SUPPORTED_LANGUAGE_CODES } from "./constants/supportedLanguages";

i18n
  .use(
    new Backend(null, {
      loadPath: "/app/locales/{{lng}}/{{ns}}.json",
    })
  )
  .use(initReactI18next)
  .init({
    supportedLngs: SUPPORTED_LANGUAGE_CODES,
    nonExplicitSupportedLngs: true,
    // Map fr-FR → fr so /locales/fr/meeting.json loads (404s were breaking namespaces)
    load: "languageOnly",
    fallbackLng: ["da", "en"],
    ns: ["translation", "meeting"],
    defaultNS: "translation",
    debug: false,
    interpolation: {
      escapeValue: false,
    },
    react: {
      // Prevent useTranslation() from suspending during language loads.
      // Without this, switching languages causes React to "replay" the entire
      // component from scratch, resetting all useState back to initial values.
      useSuspense: false,
    },
  });

export default i18n;
